/* App-style header: cart badge and cart drawer binding. */
(function () {
  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    /* ---- Cart icon opens the drawer -------------------------------------
       Dawn wires the drawer to #cart-icon-bubble in its own header, which this
       theme hides on mobile — so this icon needs the same binding or it just
       follows its href to /cart. */
    var navCart = document.querySelector('.pbx-mobile-nav__cart');
    if (navCart) {
      var openDrawer = function (event) {
        var drawer = document.querySelector('cart-drawer');
        // No drawer, or not upgraded yet? Let the link navigate to /cart.
        if (!drawer || typeof drawer.open !== 'function') return;
        event.preventDefault();
        drawer.open(navCart);
      };
      navCart.setAttribute('role', 'button');
      navCart.setAttribute('aria-haspopup', 'dialog');
      navCart.addEventListener('click', openDrawer);
      navCart.addEventListener('keydown', function (event) {
        if (event.code && event.code.toUpperCase() === 'SPACE') openDrawer(event);
      });
    }

    /* ---- Cart badge stays in step with the cart ---- */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        var count = event && event.cartData ? event.cartData.item_count : undefined;
        if (typeof count !== 'number') return;
        var cartLink = document.querySelector('.pbx-mobile-nav__cart');
        var badge = document.getElementById('pbx-mobile-cart-badge');
        if (!cartLink) return;
        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'pbx-mobile-nav__cart-badge';
            badge.id = 'pbx-mobile-cart-badge';
            cartLink.appendChild(badge);
          }
          badge.textContent = count;
        } else if (badge) {
          badge.remove();
        }
      });
    }
  });
})();
